import * as types from '../mutationTypes';

const state = {
  config: null,
};

const actions = {
  setConfig({ commit }, payload) {
    commit(types.SET_CONFIG, payload);
  },
};

const mutations = {
  [types.SET_CONFIG](state, payload) {
    state.config = payload;
  },
};

export const config = {
  namespaced: true,
  state,
  actions,
  mutations,
};
